const MAILCHIMP_ID = "beff132f6c";
const MAILCHIMP_U = "30fac2753a571efcb20ded456";

export { MAILCHIMP_ID, MAILCHIMP_U };
